module.exports = __webpack_public_path__ + "static/img/th.03b95d24.png";